<template>
  <div class="yespro" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="address" v-if="address != null" @click="$router.push('address')">
      <div class="left">
        <span>{{address.name}}</span>
        <span>{{address.phone}}</span>
      </div>
      <div class="right">
        <font>{{address.address}}</font>
      </div>
      <img src="~assets/images/icon5.png" />
    </div>


    <div class="address" v-else @click="$router.push('address')">
      <img src="~assets/images/icon5.png" />
      <span style="float:left;color:#666;padding:10px 20px;font-size:15px;letter-spacing:1px;">添加收货地址</span>
    </div>

    <div class="pro">
      <div class="goods">
        <img class="left" :src="baseUrl+detail.img[0]" />
        <div class="right">
          <p>{{detail.title}}</p>
          <div class="num">购买数量：1件</div>
          <div class="price">
            <i>￥</i><b>{{detail.rate.split(".")[0]}}</b>
            <i>.{{detail.rate.split(".")[1]}}</i>
          </div>
        </div>
      </div>
      <div class="email">
        配送费 <span>￥0.00</span>
      </div>
      <div class="email">
        备<i style="opacity:0">送</i>注 <textarea v-model="remark" placeholder="备注：请填写颜色、尺码、花型等"></textarea>
      </div>      
    </div>
    <div class="remark">具体送达时间以快递为准，不可指定送达时间，详询400-837-9800</div>

    <div style="height:50px"></div>

    <div class="footer1">
      <div class="foot-title">
        <span>1件商品</span>
        <span>
          <i>￥</i><b>{{detail.rate.split(".")[0]}}</b>
          <i>.{{detail.rate.split(".")[1]}}</i>
        </span>
      </div>
      <div class="pay" @click="order">
        <span>提交订单</span>        
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        detail:[],
        address:[],
        userData:[],
        remark:''
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      order:function(){
        var that = this;
        var pro_id = this.$route.query.id;
        var price = that.detail.rate;
        var num = 1;
        var user_id = that.userData.id;
        var name = that.address.name;
        var phone = that.address.phone;
        var address = that.address.address;
        if(address == ''){
          alert('请先添加收货地址');
          return false;
        }
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/order',
          params:{
            pro_id:pro_id,
            price:price,
            num:num,
            user_id:user_id,
            name:name,
            phone:phone,
            address:address,
            remark:that.remark
          }
        }).then(function(response){
          var order_id = response.data.data;
          that.toPush(order_id,'payment')
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },

      getDetail:function(){
        var that = this;
        var p_id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/proDetail',
          params:{
            p_id:p_id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data.data;
          that.detail = res.rs;
          that.address = res.address;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .yespro{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
    padding-top:15px
  }
  .yespro .address{
    background:#fff;
    display:block;
    position: relative;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    width:94%;
    margin:0 auto 15px auto;
    padding:10px 0
  }
  .yespro .address:after,.yespro .goods:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .yespro .address img{
    position: absolute;
    right:20px;
    top:50%;
    transform: translateY(-50%);
    width:10px;
  }
  .yespro .address .left{
    display:block;
    width:80%;
    height:35px;
    line-height:35px;
  }

  .yespro .address .left span:first-child{
    font-size: 15px;
    color: #333333;
    padding-left:15px;
  }
  .yespro .address .left span:last-child{
    float:right;
    font-size: 15px;
    color: #666;

  }
  .yespro .address .right{
    margin-top:10px;
    display:block;
    width:80%;
  }
  .yespro .address .right font{
    font-size: 14px;
    font-family: PingFangSC;
    font-weight: 400;
    color: #666666;
    padding-left:15px;
    padding-bottom:10px;
  }

  .yespro .pro{
    background:#fff;
    display:block;
    width:94%;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    margin:0 auto;
    padding-bottom:15px;
  }
  .yespro .goods .left{
    float:left;
    width:30%;
    border-radius:5px;
    margin:4% 2% 4% 4%
  }
  .yespro .goods .right{
    float:left;
    margin-top:4%;
    width:62%
  }
  .yespro .goods .right p{
    font-weight:bold;
    letter-spacing:1px;
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#333
  }
  .yespro .goods .right .num{
    font-size: 14px;
    color: #999999;
    padding-top:10px;
  }
  .yespro .goods .right .price{
    color:#f00;
    font-size:15px;
    padding-top:10px
  }

  .yespro .goods .right .price b{
    color: #FF6600;
    font-size:17px;
    font-weight:600;
  }

  .yespro .goods .right .price i{
    color: #FF6600;
    font-size:12px;
    font-style:normal
  }
  
  .yespro .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }
  .yespro textarea{
    display:inline-block;
    width:75%;
    height:60px;
    border:none;
    font-size:15px;
    outline:none;
    vertical-align:top;
    margin-left:15px;
    background:#fff;
    resize: none;
  }

  .yespro .remark{
    display:block;
    width:94%;
    color:#999;
    font-size:14px;
    letter-spacing:1px;
    margin:0 auto;
    padding:10px 0 15px 0
  }

  .yespro .email{
    background:#fff;
    margin-top:8px;
    padding:0 4%;
    font-size:15px;
    color:#999;
    vertical-align:top;
    margin-bottom:20px;
  }
  .yespro .email span{
    color:#666;
    font-size: 15px;
    padding-left:15px;
  }

  .footer1{
    height: 50px;
    background: #fff;
    width: 94%;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    position: fixed;
    bottom: 10px;
    left: 3%;
    z-index: 1
  }
  .yespro .footer1 .foot-title{
    float: left;
    margin-left: 4%;
    height:50px;
    line-height:50px;
  }
  .yespro .footer1 .foot-title span{
    font-size: 14px;
    color: #727272;
    margin-right:15px;
  }
  .yespro .footer1 .foot-title span:last-child{
    font-size: 16px;
    color: #f00;
    position: relative;
    left: -4rpx;
    font-weight: bold
  }
  .yespro .footer1 .foot-title span b{
    color: #FF6600;
    font-size:17px;
    font-weight:600;
  }

  .yespro .footer1 .foot-title span i{
    color: #FF6600;
    font-size:12px;
    font-style:normal
  }
  
  
  .yespro .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 4%;
    margin-top:5px;
    width:40%
  }
  .yespro .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #FF751A;
    border-radius:40px;
  }

</style>